import { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { getColumnasDetalleRecurrentes } from "../../constants"
import "../../style.scss"

const FacturaDetail = ({
  facturaInfo,
  openModalAdjuntos,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const onGetLabels = useCallback(
    () => getColumnasDetalleRecurrentes(openModalAdjuntos, t),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [openModalAdjuntos]
  )

  const onRenderInfoBoxes = useMemo(() => {
    return onGetLabels().map((column) => {
      return (
        <div
          key={column.label}
          className='box_container'
        >
          <h6>{column.label}</h6>
          <p
            className={column.className}
            onClick={column.onClick && column.onClick}
          >
            {column.format
              ? column.format(facturaInfo[column.key])
              : facturaInfo[column.key]}
          </p>
        </div>
      )
    })
  }, [onGetLabels, facturaInfo])

  return (
    <div className='mt-4 factura-recurrente_detail-container'>
      <div className='factura-detail_title'>
        <h6>{t("documentos.facturaRec.idView.detaillLabel")}</h6>
      </div>
      <div className='mt-3 factura-detail_info-container'>
        {onRenderInfoBoxes}
      </div>
      <div className='factura-detail_footer'>
        <h6>{t("documentos.facturaRec.idView.entryAccountLabel")}</h6>
        <span> {facturaInfo.cuentaContable}</span>
      </div>
    </div>
  )
}

export default FacturaDetail
